import * as React from 'react';
import GoogleSignIn from './common/google-sign-in';
import {user} from '../lib/user';
import * as User from './lib/user';
import {result} from '../lib/result';
import * as api from './api';

const css = require('./sign-in.css').default;

export default function ({onSignIn}: {
    onSignIn: (user: user) => void,
}) {
    return (
    <div id={css.main}>
        <h3>歡迎使用，請先登入</h3>
        <GoogleSignIn
            onSignin={async idToken => {
                const res = await api.user.get(idToken);
                if (result.ok(res)) {
                    const [_, user] = res;
                    User.save(user);
                    onSignIn(user);
                }
            }}/>
    </div>);
}
